var map = {
	"./a-arrow_2x.png": 952,
	"./a-edit_2x.png": 953,
	"./a-info_2x.png": 528,
	"./a-location_2x.png": 530,
	"./a-people_2x.png": 531,
	"./a-trash_2x.png": 956,
	"./arrow-down_2x.png": 957,
	"./arrow_back_2x.png": 958,
	"./c-automotive_2x.png": 964,
	"./c-credit_2x.png": 965,
	"./c-family_2x.png": 966,
	"./c-fire_2x.png": 967,
	"./c-health_2x.png": 968,
	"./c-home_2x.png": 969,
	"./c-life_2x.png": 970,
	"./c-misc_2x.png": 971,
	"./c-transport_2x.png": 972,
	"./c-workinjuries_2x.png": 973,
	"./close_2x.png": 533,
	"./document_2x.png": 975,
	"./dropdown-arrow_2x.png": 976,
	"./icn-dashboard_2x.png": 981,
	"./icn-events_2x.png": 982,
	"./icn-link_2x.png": 983,
	"./icn-marketing_2x.png": 984,
	"./l-logo_2x.png": 985,
	"./logo-glyph-white-m_2x.png": 986,
	"./logo-glyph-white_2x.png": 987,
	"./logo_2x.png": 988,
	"./m-client_2x.png": 989,
	"./m-dashboard_2x.png": 990,
	"./m-link_2x.png": 991,
	"./m-logo_2x.png": 992,
	"./m-marketing_2x.png": 993,
	"./menu_2x.png": 587,
	"./minus_2x.png": 994,
	"./n-avatar_2x.png": 995,
	"./n-claims_2x.png": 996,
	"./n-contracts_2x.png": 997,
	"./n-source_2x.png": 998,
	"./n-tag_2x.png": 999,
	"./office-logo_2x.png": 1001,
	"./p-avatar_2x.png": 1002,
	"./p-close_2x.png": 1004,
	"./pdf-icon_2x.png": 1005,
	"./plus_2x.png": 1006,
	"./pro-arrow_2x.png": 589,
	"./r-close_2x.png": 1008,
	"./search_2x.png": 1010
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1017;



//////////////////
// WEBPACK FOOTER
// ./resources/images ^\.\/.*_2x\.png$
// module id = 1017
// module chunks = 0